<div class="page-content page-fill">
  @if (proposals) {
    <div class="grid-fill reconciliation-data-grid" style="max-width: 99%">
      <dx-data-grid
        #dataGrid
        [dataSource]="proposals"
        keyExpr="id"
        [showBorders]="true"
        [columnAutoWidth]="false"
        [focusedRowEnabled]="false"
        [showColumnLines]="true"
        [wordWrapEnabled]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onSelectionChanged)="onSelectionChanged($event)"
        (onCellDblClick)="rowDoubleClick($event)"
        (onRowPrepared)="rowPrepare($event)"
        >
        <dxi-column dataField="created" caption="Date" dataType="date" width="100" [sortIndex]="1" [sortOrder]="'desc'"></dxi-column>
        <dxi-column dataField="voteCount" caption="Votes" cellTemplate="nameTemplate" width="70" [visible]="!reviewOnly">
          <div *dxTemplate="let d of 'nameTemplate'">
            <a [routerLink]="" (click)="vote(d.data)">{{ !d.value ? '-----' : '(' + d.value + ' votes)' }}</a>
          </div>
        </dxi-column>
        <dxi-column dataField="description" caption="Proposal" width="500"></dxi-column>
        <dxi-column dataField="fromCommittee" caption="From" width="120"></dxi-column>
        <dxi-column dataField="toCommittee" caption="To" width="120"></dxi-column>
        <dxi-column dataField="notes" caption="Notes" width="500"></dxi-column>
        <dxi-column dataField="approved" dataType="date" caption="Approved" width="80"></dxi-column>
        <dxi-column dataField="declined" dataType="date" caption="Declined" width="80"></dxi-column>
        <dxo-state-storing [enabled]="true" type="localStorage" storageKey="proposals-list-grid"></dxo-state-storing>
        <dxo-filter-row [visible]="!reviewOnly"></dxo-filter-row>
        <dxo-search-panel [visible]="!reviewOnly"></dxo-search-panel>
        <dxo-selection mode="multiple" showCheckBoxesMode="true"></dxo-selection>
        <div *dxTemplate="let data of 'toolbarButtons'">
          @if (!reviewOnly) {
            <button (click)="add()" class="btn btn-secondary ms-2">New</button>
          }
          @if (!reviewOnly) {
            <button
              type="button"
              class="btn btn-success ms-4"
              (click)="approveDecline('approve')"
              [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
              >
              Approve
            </button>
          }
          @if (!reviewOnly) {
            <button
              type="button"
              class="btn btn-danger ms-1"
              (click)="approveDecline('decline')"
              [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
              >
              Decline
            </button>
          }
          @if (!reviewOnly) {
            <button
              type="button"
              class="btn btn-secondary ms-1"
              (click)="approveDecline('clear')"
              [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
              >
              Clear
            </button>
          }
          @if (!reviewOnly) {
            <button (click)="emailPropsal()" class="btn btn-primary ms-4" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
              Email / Text Vote
            </button>
          }
          @if (!reviewOnly) {
            <button (click)="delete()" class="btn btn-sm btn-danger ms-4" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">Delete</button>
          }
          @if (!reviewOnly) {
            <button (click)="print()" class="btn btn-sm btn-primary ms-4" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">Print</button>
          }
          @if (!reviewOnly) {
            <button (click)="toggleShowAll()" class="btn btn-sm btn-warning ms-2">{{ showAll ? 'Show Recent' : 'Show All' }}</button>
          }
        </div>
        <div *dxTemplate="let data of 'toolbarText'">
          @if (proposals) {
            <span class="me-3">
              <strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong>
            </span>
          }
        </div>
      </dx-data-grid>
    </div>
  }
</div>
